import { resources } from "@constants/hardcoded-strings";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { updateRelyingParties } from "@redux/actions/relying-parties-actions";
import { deleteRelyingPartyRequest } from "@requests/axnadmin-core/delete-relying-party";

export const deleteRelyingPartyReduxRequest = (dispatch: Dispatch) => async (
    relyingPartyId: string
): Promise<AxnRelyingParty> => {
    const { data, error } = await deleteRelyingPartyRequest(relyingPartyId);
    if (data) {
        displaySuccessModal(
            dispatch,
            resources.requests.deleteRelyingParty.success.title,
            resources.requests.deleteRelyingParty.success.message
        );
        dispatch(updateRelyingParties(data.transferObject, GenericAccountStateTypes.DELETE));
        return data.transferObject;
    } else {
        if (error) {
            const errorResource = resources.requests.deleteRelyingParty.error;

            logAndDisplayErrorModal(
                dispatch,
                error,
                errorResource.title,
                errorResource.message
            );
        }
    }

    return null;
};